@import '../../utils/global.module.less';
.container {
    padding: @side-padding;
    padding-top: 20px;
    padding-bottom: 15px;
    background-color: white;
    padding-left: var(--main-container-side-padding);
    padding-right: var(--main-container-side-padding);
}

.feedbackButton {
    position: absolute;
    right: 1px;
    top: 1px;
    background-color: #102442 !important;
    color: white !important;
    font-family: LustTextMedium;
    transform: scale(0.4);
    opacity: 0.3;
    transition: all 0.4s ease-in-out;
    &:hover {
        opacity: 1;
        background-color: #4b6ea2 !important;
        color: white !important;
    }
}

.clientName {
    font-family: LustTextMedium;
    font-size: 25px;
    padding-right: 2px;
    transform: translateY(5px);
}
.shadow {
    filter: drop-shadow(0px 4px 10px rgba(0, 0, 0, 0.04));
}

.headerRow {
    padding-top: 10px;
}
.scorePosition {
    margin-left: 50px;
    transform: scale(1) !important;
}

.title {
    font-size: 40px;
    font-family: LustTextMedium;
    color: #102442;
}

.newDealButton {
    width: 120px;
    height: 50px;
}

.plusIcon {
    &::before {
        transform: translate(0, 3px) !important;
        font-size: 20px;
    }
}

.dealDatabaseButton {
    color: #102442;
    font-family: 'Hanken Grotesk', sans-serif;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 2px;
    user-select: none;

    &:hover {
        opacity: 0.7;
    }

    i {
        font-size: 28px;
        line-height: 0;
    }
}
